//librerias y archivos de vuex
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
// modulos
import sesion from './modules/sesion';
import usuarios from './modules/usuarios';
import fraccionesarancelarias from './modules/fraccionesarancelarias';
import enviosRemitentes from './modules/envios-remitentes';
import enviosDestinatarios from './modules/envios-destinatarios';
import enviosInfoEnvio from './modules/envios-infoenvio';
import sucursales from './modules/sucursales';
import tarifas from './modules/tarifas';
import cuentas from './modules/cuentas';
import sepomex from './modules/sepomex';
import remitentesRegistro from './modules/remitentes-registro';
import destinatarioRegistro from './modules/destinatario-registro';
import contrato from './modules/contrato';
import enviosInsercion from './modules/enviosInsercion';
import passwordReset from './modules/password-reset';
import abonosEnvios from './modules/abonos-envios';
import vecona from './modules/vecona';
import insercionDirecciones from './modules/insercion-direcciones';
import enviosConsultaMostrador from './modules/enviosConsultaMostrador';
import cortesDeCaja from './modules/cortes-de-caja.js';
import vecoin from './modules/vecoin.js';
import ofuscadorFirma from './modules/ofuscador-firma.js';
import enviosEdicion from './modules/enviosEdicion.js';
import documentosInternacional from './modules/documentos-internacional.js';

const ls = new SecureLS({ encryptionSecret: 'GEfVLUuNyQZV5KYntXnLf6BZpqcF3AXgQVJG8RmCwfebALYXHq', encodingType: 'aes', isCompression: false });

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: 'paqueteriaips', reducer(tienda) {
      if (tienda.sesion.logedInUserTokens.length == 0) { // return empty state when user logged out                
        return {}
      }
      return tienda
    }, storage: {
      getItem: key => ls.get(key),
      setItem: (key, value) => ls.set(key, value),
      removeItem: key => ls.remove(key),
    },
  })],
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    sesion,
    usuarios,
    fraccionesarancelarias,
    enviosRemitentes,
    enviosDestinatarios,
    enviosInfoEnvio,
    sucursales,
    tarifas,
    cuentas,
    sepomex,
    remitentesRegistro,
    destinatarioRegistro,
    contrato,
    enviosInsercion,
    passwordReset,
    enviosConsultaMostrador,
    abonosEnvios,
    vecona,
    insercionDirecciones,
    cortesDeCaja,
    vecoin,
    ofuscadorFirma,
    enviosEdicion,
    documentosInternacional
  },
});
